import React, { createContext, useState } from "react";
import ReactDOM from "react-dom";
import { Error500 } from "../components/views/error";
import { useSnackbar } from "notistack";

const API_URL = process.env.REACT_APP_API_URL;
const API_WORDPRESS = process.env.REACT_APP_API_WORDPRESS;

export const APIContext = createContext();

const APIProvider = (props) => {
  const [loggedUser, setLoggedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading_img, setLoading_img] = useState(false);
  const [edition, setEdition] = useState(true);

  const [dialogSuccessOpen, setDialogSuccessOpen] = useState(false);
  const [dialogAlertOpen, setDialogAlertOpen] = useState(false);
  const [dialogAlertContent, setDialogAlertContent] = useState({
    titulo: "",
    mensaje: "",
    imagen: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  const [asesores, setAsesores] = useState([]);
  const [sectores, setSectores] = useState([]);
  const [contactos, setContactos] = useState([]);

  const [clientes, setClientes] = useState([]);

  const [ciudad, setCiudad] = useState([]);
  const [precalificaciones, setPrecalificaciones] = useState([]);
  //const [provincia, setProvincia] = useState([]);
  const [formulas, setFormulas] = useState({
    anticipo: 0,
    gao: 0,
    tasa_descuento: 0,
    dias: 0,
  });
  const [notificaciones, setNotificaciones] = useState({
    notif_email: "",
    notif_password: "",
    notif_services: "",
  });

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [authenticated, setauthenticated] = useState(null);

  function redirect_error(data) {
    if (data.error) {
      const element = <Error500 open="true" status={data.status} />;
      if (document.getElementById("adminContent") !== null) {
        ReactDOM.render(element, document.getElementById("adminContent"));
      } else {
        ReactDOM.render(element, document.getElementById("root"));
      }
    }
  }

  function mensajeAlert(nombre, tipo) {
    let mensaje = "";
    let variant = "default";

    if (tipo === "create") {
      mensaje = `El registro ${nombre} se agregó con exito.`;
      variant = "success";
    }
    if (tipo === "delete") {
      mensaje = `Se elimino el registro ${nombre} con exito.`;
      variant = "success";
    }
    if (tipo === "warning") {
      mensaje = `No se puede eliminar el registro ${nombre} por que se encuentra utilizado en otro registro.`;
      variant = "warning";
    }
    if (tipo === "error") {
      mensaje = `Hubo un error con el registro ${nombre}, Contacte con la administración.`;
      variant = "error";
    }
    if (tipo === "error_raw") {
      mensaje = `${nombre}`;
      variant = "error";
    }
    if (tipo === "update_raw") {
      mensaje = `${nombre}`;
      variant = "success";
    }
    enqueueSnackbar(mensaje, {
      variant: variant,
    });
  }

  function DialogAlert(titulo, mensaje, imagen) {
    setDialogAlertOpen(true);
    setDialogAlertContent({
      ...dialogAlertContent,
      titulo: titulo,
      mensaje: mensaje,
      imagen: imagen,
    });
  }

  const queryBeforeDelete = async (ruta) => {
    if (ruta !== "") {
      try {
        const url = `${API_URL}${ruta}`;
        const response = await fetch(url);
        const data = await response.json();
        //return (data.body);
        if (data.body.length > 0) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    } else {
      return false;
    }
  };

  function verificar_correo(email) {
    if (email !== "") {
      if (typeof email !== "undefined") {
        let lastAtPos = email.lastIndexOf("@");
        let lastDotPos = email.lastIndexOf(".");

        if (
          !(
            lastAtPos < lastDotPos &&
            lastAtPos > 0 &&
            email.indexOf("@@") === -1 &&
            lastDotPos > 2 &&
            email.length - lastDotPos > 2
          )
        ) {
          return [false, "El Email ingresado es invalido"];
        } else {
          return [true, ""];
        }
      }
    } else {
      return [false, "Ingrese su Email"];
    }
  }

  function verificar_identificacion(tipo, identificacion) {
    let numeroCaracteres = identificacion.length;
    if (identificacion !== "") {
      if (tipo === 1) {
        if (numeroCaracteres !== 10) {
          return [
            false,
            "Número de cédula invalido. Ingrese los 10 digitos de su identificación",
          ];
        } else {
          return [true, ""];
        }
      } else {
        if (tipo === 2) {
          if (numeroCaracteres !== 13) {
            return [
              false,
              "Número de RUC invalido. Ingrese los 13 digitos de su identificación",
            ];
          } else {
            return [true, ""];
          }
        } else {
          if (numeroCaracteres > 3) {
            return [true, ""];
          } else {
            return [
              false,
              "Número de Pasaporte invalido. Ingrese más de 3 digitos de su identificación",
            ];
          }
        }
      }
    } else {
      return [false, "Número de Identifación vacio"];
    }
  }

  function verificar_celular(numero) {
    let numeroCaracteres = numero.length;
    if (numero !== "") {
      if (typeof numero !== "undefined") {
        if (numeroCaracteres !== 10) {
          return [
            false,
            "Número de celular invalido. Ingrese 10 digitos de su numero celular",
          ];
        } else {
          return [true, ""];
        }
      }
    } else {
      return [false, "Número de celular vacio"];
    }
  }

  async function verificar_borrar(ruta_exis, id, nombre) {
    let ruta = `${ruta_exis}=${id}`;
    try {
      const resp = await queryBeforeDelete(ruta);
      if (resp) {
        //si existe no borrar
        mensajeAlert(nombre, "warning");
        return false;
      } else {
        // no existe entonces borrar
        return true;
      }
    } catch {
      return false;
    }
  }

  function unCheck() {
    const x = document.querySelectorAll("th.MuiTableCell-head input")[0];
    x.click();
  }

  const uploadImage = async (files) => {
    try {
      const url = `${API_URL}upload/gc`;

      var formData = new FormData();
      formData.append("file", files[0]);

      const config = {
        method: "POST",
        body: formData,
      };
      const res = await fetch(url, config);
      const data = await res.json();
      if (res.status === 500) {
        throw new Error(
          `Hubo un error al momento de subir la imagen : ${files[0].name}`
        );
      } else {
        return data;
      }
    } catch (error) {
      mensajeAlert(error, "error_raw");
      console.log(error);
    }
  };

  const getImage = async (File) => {
    try {
      const url = `${API_URL}upload/${File}`;
      const response = await fetch(url);
      const data = response;
      return data.url;
    } catch (error) {
      console.log(error);
    }
  };

  const getImageGc = async (File) => {
    try {
      const url = `${API_URL}upload/gc/${File}`;
      const response = await fetch(url);
      const data = response;
      return data.url;
    } catch (error) {
      console.log(error);
    }
  };

  // ASESORES
  const listAsesores = async () => {
    try {
      const url = `${API_URL}asesor`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        await rewriteAsesores(data.body);
        setAsesores(data.body);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function rewriteAsesores(array) {
    array.map((arr) => {
      if (arr.ase_tipide === 1) {
        arr.ase_tipide_nom = "Cédula";
      } else {
        if (arr.ase_tipide === 2) {
          arr.ase_tipide_nom = "RUC";
        } else {
          arr.ase_tipide_nom = "Pasaporte";
        }
      }
      if (arr.ase_estado === 1) {
        arr.ase_estado_nom = "Activo";
      } else {
        arr.ase_estado_nom = "Inactivo";
      }
      if (arr.ase_rol === 1) {
        arr.ase_rol_nom = "Desarrollador";
      } else {
        if (arr.ase_rol === 2) {
          arr.ase_rol_nom = "Admistrador";
        } else {
          if (arr.ase_rol === 3) {
            arr.ase_rol_nom = "Colaborador";
          } else {
            arr.ase_rol_nom = "Atención al cliente";
          }
        }
      }
      return arr;
    });
    return array;
  }

  const getAsesor = async (id) => {
    try {
      const url = `${API_URL}asesor/search?id=${id}`;
      const response = await fetch(url);
      const data = await response.json();
      return data.body;
    } catch (error) {
      console.log(error);
    }
  };

  const updateAsesor = async (data) => {
    try {
      const url = `${API_URL}asesor`;
      const config = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      console.log(data);
      const response = await fetch(url, config);
      const res = await response.json();
      const data3 = res.body.data;
      let newAsesores = asesores.map((asesor) =>
        asesor.id === data3.id ? data3 : asesor
      );
      newAsesores.password = data.password;
      setAsesores(newAsesores);
    } catch (e) {
      return e;
    }
  };

  const createAsesor = async (data) => {
    try {
      const url = `${API_URL}asesor`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data2 = res.body.data;

      setAsesores([...asesores, data2]);
      mensajeAlert(data2.ase_nombre, "create");
      //await pushAsesor(id);
    } catch (e) {
      return e;
    }
  };

  const deleteAsesor = async (id, nombre, deleteIds) => {
    try {
      const url = `${API_URL}asesor/delete/?id=${id}`;
      const config = {
        method: "POST",
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data = res;
      if (data.error) {
        mensajeAlert(nombre, "error");
      } else {
        var newAsesores = asesores.filter(function (e) {
          return !deleteIds.includes(e.id);
        });
        setAsesores(newAsesores);
        mensajeAlert(nombre, "delete");
      }
    } catch (e) {
      mensajeAlert(nombre, "error");
      return e;
    }
  };

  // SECTORES
  const listSectores = async () => {
    try {
      const url = `${API_URL}sector`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        await rewriteSectores(data.body);
        setSectores(data.body);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function rewriteSectores(array) {
    array.map((arr) => {
      if (arr.sect_estado === 1) {
        arr.sect_estado_nom = "Activo";
      } else {
        arr.sect_estado_nom = "Inactivo";
      }

      return arr;
    });
    return array;
  }

  const getSector = async (id) => {
    try {
      const url = `${API_URL}sector/search?id=${id}`;
      const response = await fetch(url);
      const data = await response.json();
      return data.body;
    } catch (error) {
      console.log(error);
    }
  };

  const updateSector = async (data) => {
    try {
      const url = `${API_URL}sector`;
      const config = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      console.log(data);
      const response = await fetch(url, config);
      const res = await response.json();
      const data3 = res.body.data;
      let newSectores = asesores.map((sector) =>
        sector.id === data3.id ? data3 : sector
      );
      setSectores(newSectores);
    } catch (e) {
      return e;
    }
  };

  const createSector = async (data) => {
    const nombre = data.sect_nombre;
    try {
      const url = `${API_URL}sector`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data2 = res.body.data;
      const id = res.body.insertId;
      data2.sect_id = id;

      if (res.body.error) {
        mensajeAlert(nombre, "error");
      } else {
        setSectores([...sectores, data2]);
        mensajeAlert(data2.sect_nombre, "create");
      }
      //await pushAsesor(id);
    } catch (e) {
      mensajeAlert(nombre, "error");
      return e;
    }
  };

  const deleteSector = async (id, nombre, deleteIds) => {
    try {
      const url = `${API_URL}sector/delete/?sect_id=${id}`;
      const config = {
        method: "POST",
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data = res;
      if (data.error) {
        mensajeAlert(nombre, "error");
      } else {
        var newSectores = sectores.filter(function (e) {
          return !deleteIds.includes(e.sect_id);
        });
        setSectores(newSectores);
        mensajeAlert(nombre, "delete");
      }
    } catch (e) {
      mensajeAlert(nombre, "error");
      return e;
    }
  };

  // CLIENTES

  // const listClientes = async () => {
  //   setLoading_img(true);
  //   try {
  //     const url = `${API_URL}cliente`;
  //     const response = await fetch(url);
  //     const data = await response.json();
  //     if (data.error) {
  //       redirect_error(data);
  //     } else {
  //       setLoading_img(false);
  //       rewriteClientes(data.body);
  //       setClientes(data.body);
  //     }
  //   } catch (error) {
  //     setLoading_img(false);
  //     console.log(error);
  //   }
  // };

  // const listClientesFull = async () => {
  //   setLoading_img(true);
  //   try {
  //     const url = `${API_URL}cliente/full`;
  //     const response = await fetch(url);
  //     const data = await response.json();
  //     if (data.error) {
  //       redirect_error(data);
  //     } else {
  //       setLoading_img(false);
  //       rewriteClientes(data.body);
  //       setClientes(data.body);
  //     }
  //   } catch (error) {
  //     setLoading_img(false);
  //     console.log(error);
  //   }
  // };

  function rewriteClientes(array) {
    array.map((arr) => {
      if (arr.cli_tipide === 1) {
        arr.cli_tipide_nom = "Cédula";
      } else {
        if (arr.cli_tipide === 2) {
          arr.cli_tipide_nom = "RUC";
        } else {
          arr.cli_tipide_nom = "Pasaporte";
        }
      }
      if (arr.cli_estado === 1) {
        arr.cli_estado_nom = "Activo";
      } else {
        arr.cli_estado_nom = "Inactivo";
      }
      return arr;
    });
    return array;
  }

  const getCliente = async (id) => {
    try {
      const url = `${API_URL}cliente/search?cli_id=${id}`;
      const response = await fetch(url);
      const data = await response.json();
      rewriteClientes(data.body);
      return data.body;
    } catch (error) {
      console.log(error);
    }
  };

  const getClienteFull = async (id) => {
    try {
      const url = `${API_URL}cliente/full/${id}`;
      const response = await fetch(url);
      const data = await response.json();
      rewriteClientes(data.body);
      return data.body;
    } catch (error) {
      console.log(error);
    }
  };

  const getClienteCotizacion = async (id) => {
    try {
      const url = `${API_URL}join/cliente_cotizacion/search?cot.ase_id=${id}`;
      const response = await fetch(url);
      const data = await response.json();
      rewriteClientes(data.body);
      return data.body;
    } catch (error) {
      console.log(error);
    }
  };

  const updateCliente = async (data) => {
    try {
      const url = `${API_URL}cliente`;
      const config = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();

      const data3 = res.body.data;
      data3.ciu_nombre = data.ciu_nombre;
      const newClientes = clientes.map((cliente) =>
        cliente.cli_id === data3.cli_id ? data3 : cliente
      );
      setClientes(newClientes);
    } catch (e) {
      return e;
    }
  };

  const createCliente = async (data) => {
    try {
      const url = `${API_URL}cliente`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data2 = res.body.data;
      setClientes([...clientes, data2]);
      mensajeAlert(data2.cli_nombre, "create");
      //await pushCliente(id);
    } catch (e) {
      return e;
    }
  };

  const deleteCliente = async (id, nombre, deleteIds) => {
    try {
      const url = `${API_URL}cliente/delete/?cli_id=${id}`;
      const config = {
        method: "POST",
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data = res;
      if (data.error) {
        mensajeAlert(nombre, "error");
      } else {
        var newClientes = clientes.filter(function (e) {
          return !deleteIds.includes(e.cli_id);
        });
        setClientes(newClientes);
        mensajeAlert(nombre, "delete");
      }
    } catch (e) {
      mensajeAlert(nombre, "error");
      return e;
    }
  };

  // AUTH FACTOR FOX LOGIN
  const signInFactorFox = async (data) => {};

  // AUTH LOGIN
  const signIn = async (data) => {
    setLoading(true);
    try {
      const url = `${API_URL}auth/login`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const token = res.body;

      if (!res.error) {
        const x = await getUser(data.username);
        if (x.error) {
          throw new Error(x.mensaje);
        } else {
          setToken(token);
          setauthenticated(true);
          localStorage.setItem("token", token);
          setLoading(false);
          return true;
        }
      }
      throw new Error(res.body);
    } catch (err) {
      setLoading(false);
      if (err instanceof TypeError) {
        DialogAlert(
          "Error al ingresar",
          "Se ha generado un error interno, comuníquese con el administrador del sistema"
        );
        return false;
      } else {
        DialogAlert("Error al ingresar", err.message);
        return false;
      }
    }
  };

  // RECUPERAR CONTRASENA
  const sendPasswordEmail = async (data) => {
    setLoading(true);
    try {
      const url = `${API_URL}auth/sendPassword`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      if (res.error) {
        throw new Error(res.body);
      } else {
        setLoading(false);
        DialogAlert(
          "Restablecer contraseña",
          "Se ha enviado el link para restablecer su contraseña a su correo electrónico."
        );
        return;
      }
    } catch (err) {
      setLoading(false);
      DialogAlert("Restablecer contraseña", err.message);
      return err.message;
    }
  };

  const sendResetPass = async (data) => {
    setLoading(true);
    try {
      const url = `${API_URL}auth/resetPassword`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      if (res.error) {
        throw new Error(res.body);
      } else {
        setLoading(false);
        DialogAlert(
          "Actualización contraseña",
          "Se ha modificado su contraseña exitosamente, revise su correo electrónico con la información ingresada."
        );
        return;
      }
    } catch (err) {
      setLoading(false);
      DialogAlert("Error actualización contraseña", err.message);
      return err.message;
    }
  };

  const sendInfo = async (data) => {
    setLoading(true);
    try {
      const url = `${API_URL}mail/send-personal-info`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      await fetch(url, config);
      //const response = await fetch(url, config);
      //const res = await response.json();
      /* if (res.error) {
                throw new Error(res.body);
            }else{ */
      setLoading(false);
      DialogAlert(
        "Información enviada",
        "Se ha enviado la información ingresada al personal encargado."
      );
      return;
      //}
    } catch (err) {
      setLoading(false);
      DialogAlert("Error enviar información", err.message);
      return err.message;
    }
  };

  const sendTest = async (data) => {
    setLoading(true);
    try {
      const url = `${API_URL}mail/test`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      await fetch(url, config);
      const response = await fetch(url, config);
      const res = await response.json();
      if (res.error) {
        throw new Error(res.body.response);
      } else {
        setLoading(false);
        DialogAlert("Test", "Se ha enviado la comprobación correctamente.");
        return;
      }
    } catch (err) {
      setLoading(false);
      DialogAlert("Error en Test", err.response ? err.response : err.message);
      return err.response ? err.response : err.message;
    }
  };

  const verificarTokenRestablecer = async (id) => {
    setLoading(true);
    try {
      const url = `${API_URL}auth/verificarSolicitud/${id}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        throw new Error(data.body);
      } else {
        setLoading(false);
        return data;
      }
    } catch (error) {
      setLoading(false);
      DialogAlert("Restablecer contraseña", error.message);
      return error;
    }
  };

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setLoggedUser(null);
    setToken(null);
    setauthenticated(false);
  };

  const checkAuth = () => {
    const tokenStoraged = localStorage.getItem("token");
    const userStoraged = localStorage.getItem("user");
    if (!tokenStoraged || !userStoraged) {
      return false;
    } else {
      return true;
    }
  };

  const checkUser = () => {
    const tokenStoraged = localStorage.getItem("token");
    const userStoraged = localStorage.getItem("user");
    if (typeof userStoraged === "object") {
      if (userStoraged !== null || tokenStoraged !== null) {
        setLoggedUser(JSON.parse(userStoraged));
        setToken(tokenStoraged);
        setauthenticated(true);
        alert("entre");
      } else {
        logOut();
      }
    } else {
      logOut();
    }
  };

  // USER
  const getUser = async (username) => {
    try {
      const url = `${API_URL}asesor/search?ase_email=${username}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.body[0].ase_estado === 0) {
        throw new Error(
          "El Usuario se encuentra inactivo. Por lo cual no podrá ingresar a la plataforma. Contacte con el administrador."
        );
      } else {
        setLoggedUser(data.body[0]);
        localStorage.setItem("user", JSON.stringify(data.body[0]));
        return { error: false, mensaje: "" };
      }
    } catch (error) {
      console.log(error);
      return { error: true, mensaje: error };
    }
  };

  const existUser = async (username) => {
    try {
      const url = `${API_URL}asesor/search?ase_email=${username}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.body.length > 0) {
        if (data.body[0].ase_estado === 0) {
          return 2;
        } else {
          setLoggedUser(data.body[0]);
          localStorage.setItem("user", JSON.stringify(data.body[0]));
          return 1;
        }
      } else {
        return 0;
      }
    } catch (error) {
      console.log(error);
      return 0;
    }
  };

  const listParametros = async () => {
    try {
      const url = `${API_URL}parametros`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        setNotificaciones(data.body[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateParametros = async (data) => {
    try {
      const url = `${API_URL}parametros`;
      const config = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data2 = res.body.data;
      setNotificaciones(data2);
      mensajeAlert(
        `Se actualizó los Parametros para las notificaciones`,
        "update_raw"
      );
    } catch (e) {
      return e;
    }
  };

  const listFormulasSimulador = async () => {
    try {
      const url = `${API_URL}formula`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        setFormulas(data.body[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateFormulasSimulador = async (data) => {
    try {
      const url = `${API_URL}formula`;
      const config = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data2 = res.body.data;
      console.log("res ", res);
      setFormulas(data2);
      mensajeAlert(
        `Se actualizó las formulas para la Precalificación`,
        "update_raw"
      );
    } catch (e) {
      return e;
    }
  };

  const createPrecalificacion = async (dataRaw) => {
    let data = dataRaw;
    data.acepto_buro = 1;
    data.acepto_terminos = 1;
    setLoading(true);
    try {
      const url = `${API_URL}precalificacion`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();

      if (res.error) {
        throw new Error(res);
      } else {
        setLoading(false);
        setDialogSuccessOpen(true);
        return res;
      }
    } catch (err) {
      setLoading(false);
      DialogAlert(
        "Error enviar información",
        "Se ha generado un error. Por favor intente mas tarde."
      );
      return err.message;
    }
  };

  const listPrecalificaciones = async (estado) => {
    let ruta = "";
    if (estado !== "" || estado !== "undefined") {
      ruta = `/search-full?estado=${estado}`;
    }
    try {
      const url = `${API_URL}precalificacion${ruta}`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        setPrecalificaciones(data.body);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getPrecalificacion = async (id) => {
    try {
      const url = `${API_URL}precalificacion/search-full?id=${id}`;
      const response = await fetch(url);
      const data = await response.json();
      return data.body[0];
    } catch (error) {
      console.log(error);
    }
  };

  const updatePrecalificacion = async (data, resp) => {
    if (resp) {
      data.estado = resp;
    }
    try {
      const url = `${API_URL}precalificacion`;
      const config = {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data2 = res.body.data;
      const newPrecalificacion = precalificaciones.map((pre) =>
        pre.id === data2.id ? data2 : pre
      );
      setPrecalificaciones(newPrecalificacion);
      mensajeAlert(
        `Se actualizó el estado de la Precalificación # ${data2.id}`,
        "update_raw"
      );
    } catch (e) {
      return e;
    }
  };

  const listCiudad = async () => {
    try {
      const url = `${API_URL}ciudad`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        setCiudad([...data.body]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const listWPPost = async (ruta) => {
    try {
      //let x = []
      const url = `${API_WORDPRESS}posts${ruta ? ruta : ""}&_embed`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getWPPost = async (ruta) => {
    try {
      const url = `${API_WORDPRESS}posts${ruta ? ruta : ""}&_embed`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getWPRaw = async (ruta) => {
    try {
      const url = `${ruta ? ruta : ""}`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  // const getDataAnexo = async (x) => {
  //   return Promise.all(
  //     x.map(async (datax) => {
  //       let w = await getWPRaw(datax._links.author[0].href);
  //       let y = datax;
  //       y.author_data = w;
  //       return y;
  //     })
  //   );
  // };

  const listWPCategories = async (ruta) => {
    try {
      const url = `${API_WORDPRESS}categories/${ruta ? ruta + "&_embed" : ""}`;
      const response = await fetch(url);
      const data = await response.json();
      const newData = await arreglarListCategories(data);
      return newData;
    } catch (error) {
      console.log(error);
    }
  };

  const getWPCategories = async (ruta) => {
    try {
      const url = `${API_WORDPRESS}categories/${ruta ? ruta : ""}`;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const arreglarListCategories = async (x) => {
    let category = [];
    let resp = [];

    function buscarPadre(arrayx, id) {
      let resp = {};
      Promise.all(
        arrayx.map((y) => {
          if (y.id === id) {
            resp = y;
          }
          return true;
        })
      );
      return resp;
    }

    Promise.all(
      x.map(async (datax) => {
        if (datax.parent > 0) {
          let padre = await buscarPadre(x, datax.parent);
          padre.child = datax;
          category.push(padre);
        } else {
          let notchild = datax;
          notchild.child = {};
          category.push(notchild);
        }
      })
    );
    Promise.all(
      category.map(async (datax) => {
        if (datax.parent === 0) {
          resp.push(datax);
        }
      })
    );
    return resp;
  };

  const suscribirMailchimp = async (array) => {
    setLoading(true);
    try {
      const url = `${API_URL}subscribir`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(array),
      };
      const response = await fetch(url, config);
      const data = await response.json();
      setLoading(false);
      if (!data.error) {
        if (data.body.exist) {
          DialogAlert(
            "Subscripción",
            "Su correó electrónico se encuentra subscrito y activo en nuestro sitio web."
          );
        } else {
          DialogAlert(
            "Subscripción",
            "Se ha subscrito exitosamente en nuestro sitio web."
          );
        }
      } else {
        if (data.status === 403) {
          DialogAlert(
            "Subscripción",
            "Su correo electrónico se encuentra pendiente o archivado, por favor, contacte con el administrador para activarlo"
          );
        } else {
          throw new Error(
            "Se ha generado un error. Por favor intente mas tarde."
          );
        }
      }
    } catch (err) {
      setLoading(false);
      DialogAlert("Error", err.message);
      return false;
    }
  };

  // Contacto
  const sendContact = async (dataRaw) => {
    setLoading(true);
    try {
      const url = `${API_URL}contacto/`;
      const config = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataRaw),
      };

      const response = await fetch(url, config);
      setLoading(false);
      if (!response.ok) {
        throw new Error();
      } else {
        DialogAlert(
          "Mensaje Enviado",
          "Su solicitud de contacto se ha enviado correctamente."
        );
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      DialogAlert(
        "Error enviar información",
        "Se ha generado un error. Por favor intente mas tarde."
      );
      return err.message;
    }
  };

  const listContact = async () => {
    try {
      const url = `${API_URL}contacto`;
      const response = await fetch(url);
      const data = await response.json();
      if (data.error) {
        redirect_error(data);
      } else {
        setContactos(data.body);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteContact = async (id, nombre, deleteIds) => {
    try {
      const url = `${API_URL}contacto/delete/?id=${id}`;
      const config = {
        method: "POST",
      };
      const response = await fetch(url, config);
      const res = await response.json();
      const data = res;
      if (data.error) {
        mensajeAlert(nombre, "error");
      } else {
        var newContactos = contactos.filter(function (e) {
          return !deleteIds.includes(e.id);
        });
        setContactos(newContactos);
        mensajeAlert(nombre, "delete");
      }
    } catch (e) {
      mensajeAlert(nombre, "error");
      return e;
    }
  };

  return (
    <APIContext.Provider
      value={{
        edition,
        precalificaciones,
        ciudad,
        asesores,
        clientes,
        formulas,
        notificaciones,
        setNotificaciones,
        loggedUser,
        token,
        authenticated,
        loading,
        loading_img,
        dialogSuccessOpen,
        dialogAlertOpen,
        dialogAlertContent,
        sectores,
        contactos,

        unCheck,
        mensajeAlert,
        verificar_correo,
        verificar_identificacion,
        verificar_celular,
        setDialogSuccessOpen,
        setDialogAlertOpen,
        setDialogAlertContent,
        setEdition,
        setLoading,
        setLoading_img,
        uploadImage,
        getImage,
        getImageGc,
        checkUser,
        setLoggedUser,
        setFormulas,

        verificar_borrar,
        signIn,
        signInFactorFox,
        sendPasswordEmail,
        sendResetPass,
        sendInfo,
        sendTest,
        logOut,
        updateAsesor,
        updateSector,

        updateCliente,
        deleteCliente,
        deleteAsesor,
        deleteSector,

        checkAuth,
        verificarTokenRestablecer,
        createCliente,
        getCliente,
        getClienteFull,
        getClienteCotizacion,
        getAsesor,
        existUser,
        getSector,

        createPrecalificacion,
        listPrecalificaciones,
        getPrecalificacion,
        listFormulasSimulador,

        listAsesores,
        createAsesor,
        listSectores,
        createSector,
        updatePrecalificacion,
        updateFormulasSimulador,

        listParametros,
        updateParametros,

        listCiudad,

        listWPPost,
        getWPPost,
        getWPRaw,
        listWPCategories,
        getWPCategories,
        suscribirMailchimp,
        sendContact,
        listContact,
        deleteContact,
      }}
    >
      {props.children}
    </APIContext.Provider>
  );
};

export default APIProvider;
